import { matchService } from "../matches/matchService_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { dasModal } from "../modal_v2.js";
import { colors } from "../colors_v2.js";
import { iPop } from "../ipop_v2.js";
import { rankFormula } from "../profile/rankFormula_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

const render = async (event, element) => {
  if (
    element.id === "scoreplayerTwoContainer" &&
    (document.getElementById("scoreplayerTwo").innerText ===
      "No Match In Progress" ||
      document.getElementById("scoreplayerTwo").innerText ===
        "Waiting for them to join")
  ) {
    return;
  }
  if (
    (element.id === "scoreplayerOneContainer" &&
      document.getElementById("scoreplayerOne").innerText ===
        "No Match In Progress") ||
    document.getElementById("scoreplayerOne").innerText ===
      "Waiting for them to join"
  ) {
    return;
  }
  document.body.style.cursor = "wait";
  dasModal.render(`
    <div id="matchStats" class="stats">
      <div class="statsHeader">Match Stats</div>
      <div class="noWrap"><span class="courier loadingTextBlank shimmer"></span></div>
      <div id="matchStatsContent">
        <div class="matchStats" id="matchStatsTop">
            <div id="streaks" class="statBox">
              Streaks:
              <div>Daily Log In: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
              <div>Weekly Log In: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
              <div>Winning: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
            <!--streaks-->
            </div>
            <div class="matchStats" id="matchStatsRight">
              <div class="statBox" id="statsNumbers">
                <div>Total: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
                <div>Wins: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
                <div>Draws: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
                <div>Losses: <span class="courier loadingTextBlank loadingTextShort shimmer"></span></div>
              <!--statsNumbers-->
              </div>
            <!--matchStatsRight-->
            </div>
        <!--matchStatsTop-->
        </div>

        <div id="matchStatsBottom" class="matchStats">
          <div class="statBox" id="winRate">Win Rate: 
          <span class="noWrap courier loadingTextBlank loadingTextShort shimmer"></span>
          </div>
          <div class="statBox" id="uniqueWinRate">Unique Win Rate: 
          <span class="noWrap courier loadingTextBlank loadingTextShort shimmer"></span>
          </div>
        <!--matchStatsBottom-->
        </div>
    <!--matchStatsContent-->
    </div>
    <div id="rank">Rank<div class="i">ⓘ</div>: <span class="courier bold loadingTextBlank loadingTextShort shimmer"></span></div>
    </div>
`);

  await new Promise(requestAnimationFrame);
  const player = event.target.id.slice(5, 14);
  const result = matchService.getCurrentMatch();
  if (result.status != 200) {
    return;
  }
  const currentMatch = result.currentMatch;
  const userID =
    player === "playerOne"
      ? identityService.parseUserID(currentMatch.p1Name)
      : identityService.parseUserID(currentMatch.p2Name);
  
  // Debug logging for statsPop userID extraction
  console.log("statsPop: player =", player);
  console.log("statsPop: currentMatch.p1Name =", currentMatch.p1Name);
  console.log("statsPop: currentMatch.p2Name =", currentMatch.p2Name);
  console.log("statsPop: extracted userID =", userID, "type =", typeof userID);
  
  const identityResult = await identityService.getIdentity(userID);
  if (identityResult.status != 200) {
    // Don't leave the placeholders shimmering forever
    document.body.style.cursor = "default";
    dasModal.close();
    dasModal.render(`<div class="max">Unable to load the stats. Please try again.</div>`);
    return;
  }
  const identity = identityResult.identity;
  const keys = Object.keys(identity);
  const rank = escapeHtml(identity?.rank ?? "0000");
  const totalFinishes = identity?.totalFinishes ?? 0;
  const totalWins = identity?.totalWins ?? 0;
  const uniqueFinishes = identity?.uniqueFinishes ?? 0;
  const uniqueWins = identity?.uniqueWins ?? 0;
  const totalDraws = identity?.totalDraws ?? 0;
  const totalLosses = identity?.totalLosses ?? 0;
  const winRate =
    totalFinishes === 0 ? 0 : ((totalWins / totalFinishes) * 100).toFixed(1);
  const uniqueWinRate =
    uniqueFinishes === 0 ? 0 : ((uniqueWins / uniqueFinishes) * 100).toFixed(1);
  //let uniqueCat = identity?.uniqueCat ?? "";
  //uniqueCat = uniqueCat.replaceAll("#", " ");
  var html = `
    <div id="matchStats" class="stats">
      <div class="statsHeader">Match Stats</div>
      <div class="noWrap"><span class="courier">${escapeHtml(identity.name)}</span></div>
      <div id="matchStatsContent">
        <div class="matchStats" id="matchStatsTop">
            <div id="streaks" class="statBox">
              Streaks:
              <div>Daily Log In: <span class="courier">${
                identity.streakDailyLogIn ?? "n/a"
              }</span></div>
              <div>Weekly Log In: <span class="courier">${
                identity.streakWeeklyLogIn ?? "n/a"
              }</span></div>
              <div>Winning: <span class="courier">${
                identity.streakWins ?? "n/a"
              }</span></div>
            <!--streaks-->
            </div>
            <div class="matchStats" id="matchStatsRight">
              <div class="statBox" id="statsNumbers">
                <div>Total: <span class="courier">${totalFinishes}</span></div>
                <div>Wins: <span class="courier">${totalWins}</span></div>
                <div>Draws: <span class="courier">${totalDraws}</span></div>
                <div>Losses: <span class="courier">${totalLosses}</span></div>
              <!--statsNumbers-->
              </div>
            <!--matchStatsRight-->
            </div>
        <!--matchStatsTop-->
        </div>

        <div id="matchStatsBottom" class="matchStats">
          <div class="statBox" id="winRate">Win Rate: 
          <span class="noWrap courier">${winRate}% (${totalWins}/${totalFinishes})</span>
          </div>
          <div class="statBox" id="uniqueWinRate">Unique Win Rate: 
          <span class="noWrap courier">${uniqueWinRate}% (${uniqueWins}/${uniqueFinishes})</span>
          </div>
        <!--matchStatsBottom-->
        </div>
    <!--matchStatsContent-->
    </div>
    <div id="rank">Rank<div id="${userID}#statsPop" class="i">ⓘ</div>: <span class="courier bold"> 
       ${rank.slice(0, 4)}
     </span></div>
    </div>
`;
  dasModal.close();
  dasModal.render(html);
  document.getElementById("streaks").style.background =
    colors.getGameColor("tip");
  document.getElementById("winRate").style.background =
    colors.getGameColor("tip");
  document.getElementById("uniqueWinRate").style.background =
    colors.getGameColor("tip");
  document.getElementById("statsNumbers").style.background =
    colors.getGameColor("tip");

  document.getElementById("rank").style.background = colors.getGameColor("tip");
  document.body.style.cursor = "default";
  eventHub.registerEvent("click", `${userID}#statsPop`, renderFormulaSplainer);
};

const renderFormulaSplainer = async (event, element) => {
  const gotClicked = element.id;
  const parts = gotClicked.split("#");

  // Debug logging for renderFormulaSplainer
  console.log("renderFormulaSplainer: gotClicked =", gotClicked);
  console.log("renderFormulaSplainer: parts =", parts);
  console.log("renderFormulaSplainer: parts[0] =", parts[0], "type =", typeof parts[0]);

  const identityResult = await identityService.getIdentity(parts[0]);
  if (identityResult.status != 200) {
    return;
  }
  const identity = identityResult.identity;

  let text = "Ranking is only available for accounts.";
  if (identity.type === "account") {
    text = rankFormula.generateHTML(identity);
  }

  iPop.render({
    text: text,
    event,
  });
};

export const statsPop = {
  render,
};
